import { render, staticRenderFns } from "./Incorporacion.vue?vue&type=template&id=63f60899"
import script from "./Incorporacion.vue?vue&type=script&lang=js"
export * from "./Incorporacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports